<template>
  <div>
    <div class="blue-subhead-bg text-uppercase">
      <h1>Rebates</h1>
    </div>

    <div class="container admin-users">
      <br>
      <div class="np-left-push hidden-xs">
        <div class="row">
          <div class="col-sm-4 clickable" @click="sort.properties=['user.name']"><strong>Name</strong></div>
          <div class="col-sm-3 clickable" @click="sort.properties=['receiptNumber']"><strong>Receipt Number</strong></div>
          <div class="col-sm-3 clickable" @click="sort.properties=['dateOfPurchase']"><strong>Date</strong></div>
        </div>
      </div>

      <div class="blue-outline-nh" v-for="(receipt, index) in sortedReceiptItems" :key="index">
        <div class="row">
          <div class="col-sm-4"><span class="visible-xs-inline-block"><strong>Name:</strong></span> {{ receipt.user.name || receipt.user.username }}</div>
          <div class="col-sm-3"><span class="visible-xs-inline-block"><strong>Receipt Number: </strong></span> {{ receipt.receiptNumber }}</div>
          <div class="col-sm-3"><span class="visible-xs-inline-block"><strong>Date:</strong></span> {{ formatDate(receipt.dateOfPurchase) }}</div>
          <div class="col-sm-2 text-right">
            <a
              href="" class="admin-clickable"
              @click.prevent="goReceiptItemDetail(receipt)"
            >
              <strong>View</strong>
            </a>
            <!-- | <a href="" class="admin-clickable"><strong>Edit</strong></a> | -->
            <!-- <a href="" class="admin-clickable"><strong>Delete</strong></a> -->
          </div>
        </div>
      </div>

      <!-- pagination -->
      <!-- <div class="row">
        <div class="col-sm-6 col-sm-offset-3 text-center">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li>
                <a href="#" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li><a href="#">1</a></li>
              <li><a href="#">2</a></li>
              <li><a href="#">3</a></li>
              <li><a href="#">4</a></li>
              <li><a href="#">5</a></li>
              <li>
                <a href="#" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <br>
      </div> -->
      <br><br>
      <br>
      <router-link :to="{name: 'EditLoyaltyProgram'}" class="btn btn-lg admin-btn-primary col-md-2 col-md-offset-10">Back</router-link>
      <div class="clearfix"></div>
      <br>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import moment from 'moment'
const _ = require('lodash')

export default {
  name: 'UnapprovedRebateSubmissions',
  data () {
    return {
      sort: {
        properties: ['dateOfPurchase'],
        direction: 'ASC'
      }
    }
  },
  computed: {
    ...mapGetters('loyaltyProgram', [
      'programId',
      'unapprovedReceiptItems',
      'unapprovedReceipts'
    ]),
    ...mapState('loyaltyProgram', {
      program: state => state.program,
      receiptItems: state => state.receiptItems
    }),
    sortedReceiptItems () {
      // property, direction
      return _.sortBy(this.unapprovedReceipts, this.sort.properties)
    }
  },
  mounted () {
    this.getReceiptsByLoyaltyProgramId(this.programId)
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    ...mapActions('loyaltyProgram', [
      'getReceiptsByLoyaltyProgramId'
    ]),
    formatDate (date) {
      return moment(date).format('MM/DD/YYYY').toString()
    },
    goReceiptItemDetail (receipt) {
      this.$router.push({ name: 'ReceiptItemDetail', params: { receipt, receiptItem: receipt.receiptItems[0] } })
    }
  }
}
</script>
